import React, { FunctionComponent } from 'react';
import { useAuthContext } from '@havenengineering/module-shared-owners-ui/dist/contexts/auth';

import { EarningPotential } from '../Pricing/EarningPotential';
import styles from './SiteFeeHolding.module.scss';

const SiteFeeHolding: FunctionComponent = () => {
  const { activeAccount } = useAuthContext();

  return (
    <div className={styles.siteFeeHolding}>
      <h1>Finance</h1>
      <div className={styles.info}>
        <img src="/assets/icon_info_message.svg" />
        <h2>We can&apos;t wait to welcome you back!</h2>
        <p>
          We&apos;re busy working on site improvements to make your ownership
          experience even better. We&apos;ll be up and running shortly.
        </p>
      </div>
      {activeAccount?.accountID && activeAccount?.pitchStatus && (
        <div className={styles.widget}>
          <EarningPotential
            accountId={activeAccount.accountID}
            pitchStatus={activeAccount.pitchStatus}
          />
        </div>
      )}
    </div>
  );
};

export default SiteFeeHolding;
